module.exports = __webpack_public_path__ + "static/04-af6214429460d5fa13663ed7270d6798.png";